import React from "react";
import { Box, Typography, Link } from "@mui/material";

function Footer() {
  return (
    <Box
      component="footer"
      sx={{
        py: 2,
        px: 2,
        textAlign: "center",
        backgroundColor: "#f8f8f8",
        mt: "auto",
      }}
    >
      <Typography variant="body1">Contact Us</Typography>
      <Typography variant="body2">
        <Link href="mailto:rosadodev55@gmail.com">rosadodev55@gmail.com</Link>
      </Typography>
    </Box>
  );
}

export default Footer;
